const request = {
    invalid_input: 'Entrada inválida. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
